import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
import CommissionRoutes from "./Commission";
import CouponRoutes from "./Coupon";
// import DiscountRoutes from "./Discount";
import QuotaRoutes from "./Quota";
import ServiceChargeRoutes from "./ServiceCharge";
import SeatMigrationPolicy from "./seatMigrationPolicy";
import GoodsTransferPolicy from "./GoodsTransferPolicy";
import SeatCancellationPolicy from "./seatCancellationPolicy";
import EmailTemplateRoutes from "./EmailTemplate";
import WebTemplateRoutes from "./WebTemplate";
import CounterCoupon from "./CounterCoupon";
import CounterCommission from "./CounterCommission";
import CancellationPolicy from "./CancellationPolicy";
import CompanyConfig from "./CompanyConfig";

const ConfigurationRoutes = [
    {
        path: "configuration",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Configuration",
        icon: AdjustmentsHorizontalIcon,
        children: [
            //...ServiceChargeRoutes,
            //...CommissionRoutes,
            // ...DiscountRoutes,
            //...CouponRoutes,
            ...QuotaRoutes,
            //...SeatCancellationPolicy,
            //...SeatMigrationPolicy,
            ...GoodsTransferPolicy,
            ...WebTemplateRoutes,
            //...EmailTemplateRoutes,
            ...CounterCoupon,
            ...CounterCommission,
            ...CancellationPolicy,
            ...CompanyConfig,
        ],
    },
];

export default ConfigurationRoutes;
